import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CommonHeaderComponentModule } from '../../components/common-header/common-header.module';
import { FilterViewPage } from './filter-view';
import { StateFooterComponentModule } from '../../components/state-footer/state-footer.module';
 
@NgModule({
  declarations: [
    FilterViewPage,
  ],
  imports: [
    CommonHeaderComponentModule,
    StateFooterComponentModule,
    IonicPageModule.forChild(FilterViewPage),
  ],
  exports: [
    FilterViewPage
  ]
})
export class FilterViewModule {}


// WEBPACK FOOTER //
// ./src/pages/filter-view/filter-view.module.ts